import { Link } from "react-router-dom";
import { ShieldCheck, ClipboardCheck, Hammer, MessageCircle } from "lucide-react";
import Seo from "@/components/Seo";
import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";

const values = [
  { icon: ClipboardCheck, title: "Clear quotes", desc: "We explain what's included, what's excluded and what may affect the final price before work begins." },
  { icon: Hammer, title: "Reliable workmanship", desc: "We focus on clean finishes, strong installation and work that suits the property." },
  { icon: ShieldCheck, title: "Trusted approach", desc: "Licensed trades can be coordinated where required, so regulated work is handled properly." },
  { icon: MessageCircle, title: "Easy communication", desc: "We keep you updated before, during and after the job." },
];

const About = () => (
  <PageLayout>
    <Seo
      title="About Oz Property Services Co. – Melbourne"
      description="A Melbourne-based property maintenance, repair, upgrade and renovation support company focused on clear quotes and reliable workmanship."
      path="/about"
    />
    <PageHero
      title="About Oz Property Services Co."
      subtitle="A Melbourne-based property maintenance, repair, upgrade and renovation support company."
    />
    <section className="bg-white py-16 md:py-24">
      <div className="container max-w-3xl">
        <div className="space-y-5 text-muted-foreground leading-relaxed text-lg">
          <p>
            Oz Property Services Co. helps homeowners, landlords, property managers and small
            businesses get reliable work done properly. From interior upgrades and outdoor
            improvements to maintenance, security and renovation support, we bring a practical,
            professional approach to every job.
          </p>
          <p>
            We keep things straightforward: send us photos and details, get a clear quote, and we
            complete the work and leave the area clean. Where a job calls for regulated trades,
            licensed trades can be coordinated where required.
          </p>
          <p>
            We're part of the Oz brand family — the same straightforward, reliable approach you'd
            expect, focused on keeping your property in great shape.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mt-14">
          {values.map((v) => (
            <div key={v.title} className="bg-card rounded-2xl p-7">
              <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center mb-4">
                <v.icon className="w-6 h-6 text-dark" />
              </div>
              <h2 className="text-lg font-bold text-dark mb-2">{v.title}</h2>
              <p className="text-muted-foreground text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/get-quote"
            className="inline-block bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity"
          >
            Get a Free Quote
          </Link>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default About;
